import React from 'react';
import { FaDiscord } from 'react-icons/fa';
const rules_pkg = require('../../assets/images/rules_of_PKG.png');

export function AboutGraphRule() {
    return (
        <div className="container" id="content-container">
            <div className="row">
                <div className="col-12">
                    {/* Breadcrumb Navigation (Optional) */}
                    <nav aria-label="breadcrumb" className="margin-top-30">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item" aria-current="page"><a href="/about">About</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Rules of Prerequisite Knowledge Graph</li>
                        </ol>
                    </nav>

                    {/* Main Content */}
                    <div className="content">
                        <h1 className="font-1 margin-top-30">Rules of Prerequisite Knowledge Graph</h1>
                        
                        <p className="font-3 align-justify">
                            The Prerequisite Knowledge Graph contains two types of nodes: <strong>Topics</strong> and <strong>Subjects</strong>.
                        </p>
                        <ul className="font-3">
                            <li><strong>Topics</strong> are specific, atomic units of knowledge. Each topic represents a single, well-defined concept that stands on its own.</li>
                            <li><strong>Subjects</strong> are broader fields that encompass multiple related topics (e.g., Machine Learning, Physics, Calculus). They serve as composite nodes in the graph, grouping together topics.</li>
                        </ul>
                        <p className="font-3 align-justify">
                            Each topic and subject is connected to its prerequisites, which you must first learn to build the necessary foundation to understand the target topics. For each topic, there are recommended learning materials that learners can click on to access and study.
                        </p>
                        <p className="font-3 align-justify">
                            Topics/subjects have different states:
                        </p>
                        <ul className="font-3">
                            <li>Topics/subjects you have not started learning are shown in <span className="tkmr_node_not_learned_primary">gray</span>.</li>
                            <li>Topics/subjects you are currently learning are in <span className="tkmr_node_pending_primary">orange</span>.</li>
                            <li>Topics/subjects you have mastered are in <span className="tkmr_node_learned_primary">green</span>.</li>
                        </ul>
                        <p className="font-3 align-justify">
                            For now, learners will self-validate their progress, as we hope to implement examinations to validate their understanding of the topics.
                        </p>

                        <p className="font-3 margin-top-30">There are also other general rules.</p>
                        <p className="font-3 align-justify">
                            <b>No Cycles in the Graph:</b> The Prerequisite Knowledge Graph is a directed acyclic graph, meaning it cannot have loops or circular connections. This ensures there are no situations where a topic becomes a prerequisite for one of its own prerequisites, preventing any "chicken-and-egg" problems.
                        </p>
                        <p className="font-3 align-justify">
                            <b>Optional Prerequisites:</b> Some topics have optional prerequisites. These topics are not mandatory for understanding the next topic but can help you gain a deeper understanding if you choose to study them.
                        </p>
                        <p className="font-3 align-justify">
                            <b>Simplified Prerequisite Links:</b> When two topics share the same prerequisite, only the direct prerequisite is shown. For example, if Topic C depends on Topic B, and both rely on Topic A, you'll only see the link between Topics A and B, and Topics B and C.
                        </p>
                        <p className="font-3 align-justify">
                            <b>Subject Nodes:</b> Subject nodes display both their prerequisites and all the topics within them. A subject stays in progress (orange) until you complete all its topics. Once all the topics are mastered, the subject turns green, indicating that you have learned everything in that subject.
                        </p>

                        <img src={rules_pkg} alt="Rules of PKG" className="img-fluid" />

                        <h1 className="font-1 margin-top-30">Join Us to Build the Prerequisite Knowledge Graph</h1>
                        <p className="font-3 align-justify">
                            This is an ambitious project, and similar ideas have been attempted in the past but failed. The reason is simple: creating an accurate knowledge tree that covers a wide range of topics is not trivial.
                        </p>
                        <p className="font-3 align-justify">
                            We tackle this challenge by using large language models (LLMs) to bootstrap the graph, providing a basis to start from. However, while LLMs can help create the initial structure, they may not always provide the most accurate results. This is why expert validation is still needed.
                        </p>
                        <p className="font-3 align-justify">
                            Therefore, we are building a community of experts and volunteers to review, govern, and refine the graph, making sure we get accurate prerequisites based on expert consensus.
                        </p>
                        <p className="font-3 align-justify">
                            We are looking for founding members to develop this project. Join our <a href="https://discord.gg/UPB4yEttrZ"><FaDiscord size={16} /> Discord</a> or send us an email at <a href="mailto:info@takomori.com">info@takomori.com</a> today to collaborate on this project.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        );
    }

export default AboutGraphRule;
